module.exports = __webpack_public_path__ + "img/banner-23.b74d240c.jpg";